class ShortcutService {
    constructor($uibModal, $rootScope) {
        'ngInject';

        this.shortcuts = [];
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        $rootScope.$on('keyup', (event, args) => this.runKeyUp(event, args));
    }

    runKeyUp(event,args) {
        if(this.shortcuts.length === 0){
            return;
        }

        const validShortcuts = this.shortcuts
            .filter(shortcut => args.key === shortcut.key)
            .filter(shortcut => !!args.altKey === !!shortcut.altKey)
            .filter(shortcut => !!args.ctrlKey === !!shortcut.ctrlKey)
            .filter(shortcut => shortcut.altKey || !this.isInputElement(document.activeElement))
            .filter(shortcut => shortcut.validate());

        if(validShortcuts.length>0){
            window.setTimeout(() =>  validShortcuts[0].handle(),5);
        }
    };

    registerShortcut(config) {
        this.shortcuts.push(config);
    }

    unregisterShortcut(shortcut) {
        this.shortcuts = this.shortcuts.filter(sc =>  this._isSameKey(sc, shortcut));
    }

    _isSameKey(key1, key2){
        return  key1.key !== key2.key &&
                key1.altKey !== key2.altKey &&
                key1.ctrlKey !== key2.ctrlKey
    }

    isInputElement(element) {
        const inputs = ['input', 'select', 'textarea'];
        return element && inputs.indexOf(element.tagName.toLowerCase()) !== -1;
    }
}


(function () {
    'use strict';
    angular.module('doclr.components.util')
        .service('ShortcutService', ShortcutService);
})();